(() => {
  'use strict';
  const root = document.querySelector('#m9-pilot');
  if (!root || root.dataset.initialized) return;
  const q = s => root.querySelector(s), all = s => [...root.querySelectorAll(s)];
  const native = [...document.querySelectorAll('[data-product-id]')].find(e =>
    e.tagName.startsWith('SMART-BUY-BUTTON-') && e.dataset.productId === root.dataset.productId);
  const picker = [...document.querySelectorAll('variant-picker[data-template-product-match="true"]')]
    .find(e => e.dataset.productId === root.dataset.productId);
  // Fail open to the original PDP if purchase/variant controls cannot be preserved.
  if (!native || (root.dataset.hasVariants === 'true' && !picker)) return;
  const buy = native.querySelector('[data-action="buy-now"]');
  const qty = native.querySelector('[class*="ai-smart-buy-qty-wrapper-"]');
  const popupTitle = native.querySelector('[data-step="0"] h3');
  if (!buy || !qty || !popupTitle) return;
  root.dataset.initialized = 'true';
  const reviews = document.querySelector('#vdr-reviews');
  const contact = native.querySelector('a[class*="ai-smart-buy-contact-"]');
  // Shared PDP behavior at every viewport; CSS adapts the composition.
  const mq = matchMedia('all');
  let active = false, topic = '', index = 0, recommendationsLoaded = false;
  const images = JSON.parse(q('#m9-images').textContent);
  const marker = (node, label) => { const m = document.createComment(label); node.before(m); return m; };
  const nativeMarker = marker(native, 'PDP native checkout');
  const qtyMarker = marker(qty, 'PDP native quantity');
  const pickerMarker = picker && marker(picker, 'PDP native variants');
  const reviewsMarker = reviews && marker(reviews, 'PDP native reviews');
  // Retain a native picker's state on browsers supporting state-preserving moves.
  const move = (parent, node, before = null) => {
    if (parent.moveBefore && node.isConnected && parent.isConnected) parent.moveBefore(node, before);
    else parent.insertBefore(node, before);
  };
  const restore = (node, m) => { if (node && m?.parentNode) move(m.parentNode, node, m.nextSibling); };
  const notes = reviews ? [...reviews.querySelectorAll(':scope > .vr-note')] : [];
  const noteMarkers = notes.map(n => marker(n, 'Review policy'));
  const policy = document.createElement('details'); policy.className = 'm9-review-policy';
  const policyTitle = document.createElement('summary'); policyTitle.textContent = 'Tentang ulasan & privasi'; policy.append(policyTitle);
  function mount() {
    if (mq.matches && !active) {
      move(root.parentNode, native, root.nextSibling);
      native.classList.add('m9-native-buy'); move(popupTitle.parentNode, qty, popupTitle.nextSibling); qty.classList.add('m9-popup-qty');
      if (picker) move(q('#m9-variant-slot'), picker);
      if (reviews) {
        move(q('#m9-reviews-slot'), reviews);
        if (notes.length) { policy.append(...notes); (reviews.querySelector('[data-vr-form]') || reviews.lastElementChild)?.before(policy); }
      }
      active = true; document.body.classList.add('m9-pilot-ready'); loadRecommendations();
    } else if (!mq.matches && active) {
      all('dialog[open]').forEach(d => d.close()); native.querySelector('[data-action="cancel"]')?.click();
      restore(qty, qtyMarker); qty.classList.remove('m9-popup-qty'); restore(native, nativeMarker); native.classList.remove('m9-native-buy');
      restore(picker, pickerMarker); notes.forEach((n,i) => restore(n, noteMarkers[i])); policy.remove(); restore(reviews, reviewsMarker);
      document.body.classList.remove('m9-pilot-ready'); active = false;
    }
  }
  function setGallery(src) {
    if (!src || !q('#m9-hero')) return;
    q('#m9-hero').src = src; q('#m9-hero').removeAttribute('srcset'); q('#m9-zoom-image').src = src;
    const found = images.findIndex(x => new URL(x, location.href).pathname === new URL(src, location.href).pathname);
    index = found >= 0 ? found : 0;
    q('[data-m9-counter]').textContent = `${index + 1} / ${images.length}`;
  }
  function gallery(delta) { if (images.length) setGallery(images[(index + delta + images.length) % images.length]); }
  if (q('#m9-hero')) setGallery(q('#m9-hero').getAttribute('src'));
  all('[data-m9-prev]').forEach(b => b.onclick = () => gallery(-1));
  all('[data-m9-next]').forEach(b => b.onclick = () => gallery(1));
  if (q('[data-m9-zoom]')) q('[data-m9-zoom]').onclick = () => { q('#m9-zoom-image').src = q('#m9-hero').src; q('#m9-zoom').showModal(); };
  all('[data-m9-close]').forEach(b => b.onclick = () => b.closest('dialog').close());
  const tabs = all('[data-m9-tab]');
  function tab(key) {
    tabs.forEach(b => { const yes = b.dataset.m9Tab === key; b.setAttribute('aria-selected', String(yes)); b.tabIndex = yes ? 0 : -1; });
    all('.m9-panel').forEach(p => p.hidden = p.id !== 'm9-' + key);
  }
  tabs.forEach((b,i) => {
    b.onclick = () => tab(b.dataset.m9Tab);
    b.onkeydown = e => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
      e.preventDefault(); const n = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length-1 : (i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
      tab(tabs[n].dataset.m9Tab); tabs[n].focus();
    };
  });
  all('[data-m9-video-url]').forEach(a => {
    let url; try { url = new URL(a.dataset.m9VideoUrl); } catch { a.removeAttribute('href'); return; }
    if (!['https:','http:'].includes(url.protocol)) { a.removeAttribute('href'); return; }
    const host = url.hostname.replace(/^www\./,'');
    const id = host === 'youtu.be' ? url.pathname.slice(1).split('/')[0] : ['youtube.com','m.youtube.com'].includes(host) ? (url.searchParams.get('v') || url.pathname.match(/^\/(?:shorts|embed|live)\/([^/]+)/)?.[1]) : null;
    if (!id || !/^[\w-]{11}$/.test(id)) return; // keep the actual external fallback
    const thumb = document.createElement('span'); thumb.className = 'm9-thumb';
    const img = document.createElement('img'); img.src = 'https://i.ytimg.com/vi/'+id+'/mqdefault.jpg'; img.alt=''; img.loading='lazy'; img.width=320; img.height=180;
    const play = document.createElement('span'); play.textContent='▶'; play.setAttribute('aria-hidden','true'); thumb.append(img,play); a.prepend(thumb);
    a.onclick = e => { e.preventDefault(); q('#m9-player-title').textContent = a.dataset.title; q('#m9-player-frame').title = a.dataset.title;
      q('#m9-player-frame').src = 'https://www.youtube.com/embed/'+id+'?autoplay=1'; q('#m9-video-external').href = url.href; q('#m9-player').showModal(); };
  });
  q('#m9-player').addEventListener('close', () => q('#m9-player-frame').removeAttribute('src'));
  q('[data-m9-buy]').onclick = () => { if (!buy.disabled) buy.click(); };
  const help=q('#m9-help'), questionBox=q('[data-m9-help-questions]');
  all('#m9-faq details').forEach(d => { const clone=d.cloneNode(true); clone.open=false; clone.addEventListener('toggle',()=>{if(clone.open)topic=clone.querySelector('summary').textContent.trim();}); questionBox.append(clone); });
  q('[data-m9-help]').onclick = () => { topic=''; questionBox.querySelectorAll('details').forEach(d=>d.open=false); help.showModal(); };
  q('[data-m9-package]').onclick = () => { topic='Isi paket'; help.showModal(); };
  q('[data-m9-contact]').disabled = !contact;
  q('[data-m9-contact]').onclick = () => {
    help.close(); if (!contact) return;
    contact.dataset.vdrTopic = topic;
    contact.dataset.vdrVariant = native.dataset.variantId;
    contact.click();
  };
  root.addEventListener('click', e => {
    const a=e.target.closest('vdr-rating a'); if(!a||!active||!reviews)return; e.preventDefault(); e.stopPropagation();
    const y=reviews.getBoundingClientRect().top+scrollY-q('.m9-tabs').offsetHeight-14;
    window.scrollTo({top:Math.max(0,y),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    reviews.setAttribute('tabindex','-1'); reviews.focus({preventScroll:true});
  },true);
  // Preserve the original section-scoped price/gallery/form subscribers after moving
  // its picker. Mark forwarded events so this bridge never handles them twice.
  const nativeSection = native.closest('.shopify-section');
  const forwardVariantEvent = e => {
    if (!active || !picker?.contains(e.target) || !nativeSection || nativeSection.contains(picker)) return;
    const forwarded = new CustomEvent(e.type, {bubbles:true,detail:e.detail});
    forwarded.pdpForwarded = true; nativeSection.dispatchEvent(forwarded);
  };
  // Horizon events.js emits detail.resource + detail.data.html (not detail.variant).
  // Listen at document because the native picker changes parent on mobile.
  document.addEventListener('variant:selected', e => {
    if (e.pdpForwarded || !picker || !picker.contains(e.target)) return;
    forwardVariantEvent(e);
    native.querySelector('[data-action="cancel"]')?.click();
    buy.disabled = true; q('[data-m9-buy]').disabled = true;
  });
  document.addEventListener('variant:update', e => {
    if (e.pdpForwarded || !root.isConnected || String(e.detail?.data?.productId) !== root.dataset.productId) return;
    forwardVariantEvent(e);
    const variant=e.detail.resource, html=e.detail.data.html;
    const fresh=[...(html?.querySelectorAll('[data-product-id]')||[])].find(n=>n.tagName.startsWith('SMART-BUY-BUTTON-')&&n.dataset.productId===root.dataset.productId);
    // Quantity caps come from the selected variant's freshly server-rendered native block.
    const valid = !!variant?.id && !!fresh && String(variant.id)===fresh.dataset.variantId;
    native.dataset.variantId = valid ? String(variant.id) : '';
    native.dataset.maxQty = valid ? fresh.dataset.maxQty || '' : '0';
    native.mainMaxQty = native.dataset.maxQty !== '' ? Number(native.dataset.maxQty) : null;
    native.mainQty = 1;
    native.qtyInput.value = native.mainQty;
    native.querySelector('[data-action="decrease"]').disabled = true;
    native.querySelector('[data-action="increase"]').disabled = true;
    buy.disabled = !valid || !variant.available; buy.classList.toggle('out-of-stock',buy.disabled); buy.textContent=buy.disabled?'Stock Habis':'CHECKOUT';
    q('[data-m9-buy]').disabled=buy.disabled; q('[data-m9-buy]').textContent=buy.disabled?'Stock Habis':'Checkout';
    q('[data-m9-stock]').textContent=!valid?'Varian tidak tersedia':!variant.available?'Stock Habis':root.dataset.preorder==='true'?'Preorder':'Ready Stock';
    const price=html?.querySelector('[data-m9-price]'); if(price)q('[data-m9-price]').textContent=price.textContent;
    const image=variant?.featured_media?.preview_image?.src || variant?.featured_image?.src;
    if(image)setGallery(image);
    native.querySelector('[data-action="cancel"]')?.click();
  });
  async function loadRecommendations() {
    if (recommendationsLoaded || !root.dataset.recommendationsUrl) return;
    recommendationsLoaded=true;
    try {
      const url=new URL(root.dataset.recommendationsUrl,location.href);
      const preview=new URL(location.href).searchParams.get('preview_theme_id'); if(preview)url.searchParams.set('preview_theme_id',preview);
      const response=await fetch(url); if(!response.ok)return;
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      const result=html.querySelector('#m9-pilot .m9-recommendations');
      if(result?.querySelector('.m9-rec')){q('.m9-recommendations').replaceChildren(...result.childNodes);q('.m9-recommendations').hidden=false;}
    } catch { /* No guessed or static recommendations on an empty/error response. */ }
  }
  mq.addEventListener('change',mount); mount();
})();
